import { useState, useEffect, useRef, useCallback, useMemo } from "react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-balham.css";
import { FilterChangedEvent } from "ag-grid-community";
import "ag-grid-enterprise";
import { useTheme } from "@mui/material/styles";
import _ from "lodash";
import moment from "moment";
import axios from "axios";
import { Button, Typography } from "@mui/material";
import { validateQuantity, validateRate } from "../../common/tradeValidations";
import { enquiryColdDefs } from "../../common/locateColumnDefs";
import {
  BASE_URI_SOCKET,
  envs,
  getEnv,
  serviceAPIMapping,
} from "../../config/service-api-mapping";
import {
  constants,
  EndPoint,
  headers,
  socketMsgType,
} from "../../common/constants";
import { getRowStyle, mapRowId } from "../../common/commonFunctions";
import { AgGridReact } from "ag-grid-react";
import SockJS from "sockjs-client";
import { Stomp } from "@stomp/stompjs";
import { locateAdminEnquiryColDefs } from "../../common/columnLocateEnquiryEdit";
import RefreshIcon from "@mui/icons-material/Refresh";
import { exportMultipleSheetsAsExcel } from "ag-grid-enterprise";
import excel from "../../assets/images/excel.svg";

interface AgGridProps {
  title?: string;
  type?: string;
  onClickHan?: any;
  onClickSelectData?: any;
  onCellChange?: any;
  seTtotalSelectedRows?: any;
  getBtnRef?: any;
  getGridApi?: any;
  doesExternalFilterPass?: any;
  isExternalFilterPresent?: any;
  isDeselectAll?: boolean;
  getContextMenuItems?: any;
  globalSearch?: any;
  isSingleRowInserted?: boolean;
  defaultFilter?: any;
  onRowSelect?: any;
  isInquiriesRefreshed?: boolean;
  isAdmin?: boolean;
  onLocate?: any;
  date: any;
  newRows: any;
  enableSocketUpdates?: boolean;
  currentInterval?: number;
  globalClient?: any;
  clientList?:any
  sourceFilter?:any
  statusFilter?:any
}

const EnquiryGrid = ({
  title,
  getGridApi,
  doesExternalFilterPass,
  isExternalFilterPresent,
  isDeselectAll,
  getContextMenuItems,
  globalSearch,
  defaultFilter,
  getBtnRef,
  onRowSelect,
  isInquiriesRefreshed,
  onLocate,
  date,
  newRows,
  enableSocketUpdates,
  currentInterval,
  isAdmin,
  globalClient,
  clientList, 
}: AgGridProps) => {
  const gridRef = useRef<any>(null);
  const theme = useTheme();
  const [inquiries, setInquiries] = useState<any>([]);
  const activeClientShortName = window.localStorage.getItem(
    "activeClientShortName"
  );
  const [insertInquiryRows, setInsertInquiryRows] = useState<any>([]);
  const socketConsolidate = new SockJS(`${BASE_URI_SOCKET()}`);
  const socketConsolidateClient = Stomp.over(function () {
    return socketConsolidate;
  });

  const [statusFilter, setStatusFilter] = useState({
    isAvailableFilterActive: false,
    isUnAvailableFilterActive: false,
    isTopupFilterActive: false,
    isRejectedFilterActive: false,
    isPendingFilterActive: false,
    isPartialFilterActive: false,
  });
  const [showTotalRow, setShowTotalRow] = useState(isAdmin?false: true);
  const [isResetFilter, setIsResetFilter] = useState<boolean>(true);
  const [isUIFilterActive, setIsUIFilterActive] = useState<boolean>(false);
  const [isFileFilterActive, setIsFileFilterActive] = useState<boolean>(false);
  const [isFixFilterActive, setIsFixFilterActive] = useState<boolean>(false);
  const [initialInquiries, setInitialInquiries] = useState<any>([]);
  const [locateBkpStr, setLocateBkpStr] = useState<any>("");
  const [gridTheme, setGridTheme] = useState<string>(
    theme.palette.mode === "dark" ? " ag-theme-balham-dark" : " ag-theme-balham"
  );
  const [lastUpdatedDate, setLastUpdatedDate] = useState(
    moment(new Date()).format("MM/DD/yyyy HH:mm")
  );
 const loginUser = window.localStorage.getItem(
    "username"
  );
  const ActionRenderer = (props: any) => {
    const onLocateUpdate = (data: any, isPreBorrow: boolean) => {
      try {
        if (
          data &&
          validateQuantity(data?.request_quantity) &&
          (validateRate(data?.rebate) || data?.centpershare)
        ) {
          const req = {
            ...data,
            isPreBorrow: isPreBorrow,
          };
          // isPreBorrow ? onPreBorrow(req) : onLocate(req);
          onLocate(req);
        }
      } catch (error) {
        console.log("err", error);
      }
    };



    return (
      <>
        {!props?.data?.isTotalRow && (
          <div className="d-flex flex-row ">
            <Button
              style={{ height: "15px", width: "75px", fontSize: "11px" }}
              variant="contained"
              color="success"
              className="me-1"
              onClick={() => onLocateUpdate(props?.node?.data, false)}
              disabled={
                !(
                  props?.node?.data?.status === "Available" ||
                  props?.node?.data?.status === "Partial"
                ) ||
                props?.node?.data?.hasError ||
                !(
                  validateQuantity(props?.node?.data?.request_quantity) &&
                  (validateRate(props?.node?.data?.rebate) ||
                    props?.node?.data?.centpershare)
                )
              }
            >
              Locate
            </Button>
            <Button
              style={{ height: "15px", width: "95px", fontSize: "11px" }}
              variant="contained"
              color="success"
              onClick={() => onLocateUpdate(props?.node?.data, true)}
              disabled={true}
              // disabled={
              //   !(
              //     props?.node?.data?.status === "Available" ||
              //     props?.node?.data?.status === "Partial"
              //   ) ||
              //   props?.node?.data?.hasError ||
              //   !(
              //     validateQuantity(props?.node?.data?.request_quantity) &&
              //     (validateRate(props?.node?.data?.rebate) ||
              //       props?.node?.data?.centpershare)
              //   )
              // }
            >
              Pre BRW
            </Button>
          </div>
        )}
      </>
    );
  };

  const coldDefs = () => {
    let columns: any[] = [];
    const enqCol = isAdmin ? locateAdminEnquiryColDefs : enquiryColdDefs;
    columns = enqCol?.map((colDef: any) => {
      if (colDef?.colId === "action") {
        return {
          ...colDef,
          cellRenderer: colDef?.data?.isTotalRow ? "" : ActionRenderer,
        };
      } else {
        return colDef;
      }
    });

    return columns;
  };

  useEffect(() => {
    setGridTheme(
      theme.palette.mode === "dark"
        ? " ag-theme-balham-dark"
        : " ag-theme-balham"
    );
  }, [theme.palette.mode]);

  useEffect(() => {
    setInquiries([]);
    setInitialInquiries([]);
    if (date && !_.isUndefined(date)) {
      // do health check if not a demo user
      getInquiries();
    }
  }, [isInquiriesRefreshed, date]);

  const getName = useCallback(
    (api: any, columnApi: any) => {
      if (!api || !columnApi) return;

      if (showTotalRow) {
        const rows: any = {};
        const result: any[] = [];

        columnApi.getAllGridColumns().forEach((col: any) => {
          rows[col.colId] = null;
        });

        const numericSumFields = [
          "request_quantity",
          "approved_quantity",
          "response_quantity",
          "filled_quantity",
          "centpershare",
          "centpershare_appr",
          "rebate",
          "rate_appr",
        ];

        const averageFields = [
          "centpershare",
          "centpershare_appr",
          "rebate",
          "rate_appr",
        ];

        numericSumFields.forEach((field) => {
          api.forEachNodeAfterFilter((rowNode: any) => {
            if (rowNode?.data?.[field]) {
              rows[field] += Number(rowNode.data[field]);
            }
          });
        });

        const rowCount = api.getDisplayedRowCount();

        averageFields.forEach((field) => {
          if (rowCount && rows[field] != null) {
            rows[field] = Number((rows[field] / rowCount).toFixed(4));
          }
        });

        const getUniqueCount = (field: string): number => {
          const set = new Set<any>();
          api.forEachNodeAfterFilter((node: any) => {
            if (node.data?.[field]) {
              set.add(node.data[field]);
            }
          });
          return set.size;
        };

        rows["inquiry_id"] = getUniqueCount("inquiry_id");
        rows["ticker"] = getUniqueCount("ticker");
        rows["cpty"] = getUniqueCount("cpty");
        rows["username"] = getUniqueCount("username");
        const labelRow = {
          ticker: "Symbol",
          inquiry_id: "Rows",
          request_quantity: "Req Qty",
          approved_quantity: "Appr Qty",
          response_quantity: "Res Qty",
          filled_quantity: "Used Qty",
          cpty: "Clients",
          username: "Users",
          centpershare: "Avg Req CPS",
          centpershare_appr: "Avg Appr CPS",
          rebate: "Avg Req Rebate",
          rate_appr: "Avg Appr Rebate",
          isTotalRow: true,
          isTotalLabel: true,
        };

        rows["isTotalRow"] = true;
        result.push(labelRow);
        result.push(rows);
        api.setPinnedBottomRowData(result);
      } else {
        api.setPinnedBottomRowData([]);
      }
    },
    [showTotalRow]
  );

  const getInquiries = async () => {
    try {
      const request = isAdmin
        ? {
            date: moment(date).format("yyyy-MM-DD"),
            account: window.localStorage.getItem("activeAccountCode"),
            isInquiry: true,
          }
        : {
            date: moment(date).format("yyyy-MM-DD"),
            account: window.localStorage.getItem("activeAccountCode"),
            isInquiry: true,
            clientShortCode: activeClientShortName,
          };
      await axios
        .post(
          serviceAPIMapping["LOCATEMANAGEMENT-SERVICE"].apiRouteURL +
            EndPoint.getInquiryList,
          JSON.stringify(request),
          { headers: headers }
        )
        .then(async (response: any) => {
          if (response?.status === 200) {
            const rows = await response?.data;
            if (rows && _.isArray(rows) && rows?.length > 0) {
              const enqs = isAdmin
                ? rows?.filter((e: any) => !e?.is_wip)
                : rows;
              const dataRows = enqs?.map((row: any) => {
                return {
                  ...row,
                  inquiry_id: row?.inquiry_id,
                  centpershare: _.isNaN(row?.centpershare)
                    ? 0
                    : (+row?.centpershare)?.toFixed(4),
                  rebate: _.isNaN(row?.rebate) ? 0 : (+row?.rebate)?.toFixed(3),
                  fee: _.isNaN(row?.fee) ? +row?.fee : 0,
                  requested_time: moment(row.requested_time).format('HH:mm:ss'),
                  response_time: moment(row.response_time).format('HH:mm:ss')
                };
              });
              const mappedRows = mapRowId(dataRows);
              const sortedRows = _.orderBy(mappedRows, "updatetime", "desc");
              const uniqRows = _.uniqBy(sortedRows, 'inquiry_id')
              setInquiries(uniqRows);
              setInitialInquiries(uniqRows);
              if (
                uniqRows &&
                _.isArray(uniqRows) &&
                !_.isEmpty(uniqRows) && !isAdmin
              ) {
                onRowSelect(uniqRows[0]);
              }
            } else {
              setInquiries([]);
              setInitialInquiries([]);
            }
          } else if (response?.status === 401) {
            // logout(channel)
          } else {
            setInquiries([]);
            setInitialInquiries([]);
          }
        });
    } catch (err) {
      console.log(err);
      setInquiries([]);
      setInitialInquiries([]);
    }
  };

  const onFirstDataRendered = () => {
    let gridColumnApi = gridRef?.current!.columnApi;
    let gridRefApi = gridRef?.current!.api;
    getName(gridRefApi, gridColumnApi);
  };

  const [columnDefs] = useState(coldDefs());

  const [gridApi, setGridApi] = useState<any>(null);

  const defaultColDef = useMemo<any>(() => {
    return {
      flex: 1,
      sortable: true,
      filter: true,
      floatingFilter: false,
      suppressFilterButton: false,
      editable: false,
      resizable: true,
      headerCheckboxSelectionFilteredOnly: true,
      menuTabs: [constants.FilterMenuTab],
      tooltipShowDelay: 10,
      tooltipMouseTrack: true,
      suppressKeyboardEvent: (params: any) => {
        const isTabKey = params?.event?.key === constants.Tab;
        if (isTabKey) gridRef?.current?.api?.stopEditing();

        return false;
      },
    };
  }, []);

  useEffect(() => {
    if (defaultFilter && gridRef) {
      const filterComponent = gridRef?.current?.api?.getFilterInstance(
        defaultFilter.column
      );
      if (filterComponent) {
        filterComponent?.setModel({ values: defaultFilter.values });
        gridApi.onFilterChanged();
      }
    }
  }, [gridRef]);

  const [columnApi, setColumnApi] = useState<any>(null);
  const onGridReady = (params: any) => {
    const api = params.api;
    const colApi = params.columnApi;

    api.sizeColumnsToFit();

    setGridApi(api);
    setColumnApi(colApi); 

    if (showTotalRow) getName(api, colApi);

    if (getGridApi) {
      getGridApi(api, colApi);
    }

    if (getBtnRef) {
      getBtnRef(gridRef);
    }
  };

  useEffect(() => {
    if (gridApi && columnApi) {
      getName(gridApi, columnApi);
    }
  }, [showTotalRow, inquiries]);

  /**
   * Method counts the unique value for given attribute (for filtered values also)
   * @param attribute
   * @returns unique values count
   */
  // const countUnique = (attribute: string, api: GridApi): number => {
  //   const uniqueItemsSet: Set<any> = new Set();
  //   api?.forEachNodeAfterFilter((rowNode: any) => {
  //     if (rowNode?.data instanceof Object && attribute in rowNode.data) {
  //       uniqueItemsSet.add(rowNode.data[attribute]);
  //     }
  //   });

  //   return uniqueItemsSet.size;
  // };

  useEffect(() => {
    if (isDeselectAll != undefined) gridRef.current?.api?.deselectAll();
  }, [isDeselectAll]);

  const rowClassRules = useMemo(() => {
    return {
      "is-new-warning": (params: any) => {
        const isNew = params.data.is_new;

        return isNew === "TRUE";
      },
      "is-new-recall": (params: any) => {
        const isNew = params.data.is_Recall;

        return isNew === "True";
      },
    };
  }, []);

  const autoGroupColumnDef = useMemo(() => {
    return {
      minWidth: 100,
      maxWidth: 200,
    };
  }, []);

  const getRowId = (params: any) => {
    if (params && params?.data) {
      if (params?.data?.inquiry_id) {
        return params?.data?.inquiry_id;
      } else if (params?.data?.id) {
        return params?.data?.id;
      }
    }

    return makeid(5);
  };

  function makeid(length: any) {
    let result = "";
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < length) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
      counter += 1;
    }

    return result;
  }

  const sideBar = useMemo(() => {
    return {
      toolPanels: [
        {
          id: "columns",
          labelDefault: "Columns",
          labelKey: "columns",
          iconKey: "columns",
          toolPanel: "agColumnsToolPanel",
          toolPanelParams: {
            suppressRowGroups: true,
            suppressValues: true,
            suppressPivots: true,
            suppressPivotMode: true,
            suppressColumnFilter: false,
            suppressColumnSelectAll: false,
            suppressColumnExpandAll: true,
          },
        },
      ],
      defaultToolPanel: "",
    };
  }, []);

  function isForceRefreshSelected() {
    return (document.querySelector("#forceRefresh") as HTMLInputElement)
      ?.checked;
  }
  function isSuppressFlashSelected() {
    return (document.querySelector("#suppressFlash") as HTMLInputElement)
      ?.checked;
  }
  const onGridRowDataChanged = () => {
    const refreshParams: any = {
      force: isForceRefreshSelected(),
      suppressFlash: isSuppressFlashSelected(),
    };
    gridRef.current!.api.refreshCells(refreshParams);
  };

  const onDoesfilter = useCallback((node: any) => {
    doesExternalFilterPass(node);

    return true;
  }, []);

  const onSelectionChanged = (params: any) => {
    const selectedRows = params?.api?.getSelectedRows();
    if (selectedRows && !_.isEmpty(selectedRows)) {
      onRowSelect(selectedRows[0]);
    }
  };

  useEffect(() => {
    let returnInterval: any;

    if (enableSocketUpdates && !socketConsolidateClient?.connected) {
      socketConsolidateClient.connect(
        {},
        function (frame: any) {
          socketConsolidateClient.subscribe(
            "/topic/consolidated_message",
            async function asy(result: any) {
              let resultJson = JSON.parse(result?.body);
              if (isAdmin && getEnv() !== envs.PROD) {
                console.log(
                  `Data received from /topic/consolidated_message at ${moment()?.toDate()} - `,
                  resultJson
                );
              }

              // if (orders && _.isArray(orders) && orders?.length > 0) {
              await onSocketMsgReceive(resultJson?.socketMssgmap);

              // if (queue?.size > 0) {
              //   queue.enqueue(orders);
              // } else {
              //   queue.enqueue(orders);
              //   const msg = queue?.dequeue();
              //   await onSocketMsgReceive(msg);
              // }
              // }
            }
          );
        },
        {},
        () => {}
      );
    } else {
      if (currentInterval && currentInterval > 0) {
        returnInterval = setInterval(() => {
          getInquiries();
        }, currentInterval);
        return () => clearInterval(returnInterval);
      }
      if (socketConsolidateClient?.connected) {
        socketConsolidateClient?.unsubscribe("/topic/consolidated_message");
        socketConsolidateClient?.disconnect();
      }
      // if (queue) {
      //   queue?.clear();
      // }
    }

    return () => {
      clearInterval(returnInterval);

      if (socketConsolidateClient?.connected) {
        socketConsolidateClient?.unsubscribe("/topic/consolidated_message");
        socketConsolidateClient?.disconnect();
      }
      // if (queue) {
      //   queue?.clear();
      // }
    };
  }, [enableSocketUpdates, currentInterval]);

  const onSocketMsgReceive = (msg: any) => {
    const orders = _.get(msg, socketMsgType.LOCATE_INQUIRY);
    if (orders && _.isArray(orders) && orders?.length > 0) {
      let socketRows = [...orders]?.map((item: any) => {
        return item?.messageJson;
      });

      const locates = socketRows?.filter(
        (order: any) =>
          order?.locate_type === "INQUIRY" && order?.username !== loginUser &&
          !order?.is_wip &&
          (!isAdmin ? order?.cpty === activeClientShortName : true)
      );

      if (locates && _.isArray(locates) && locates?.length > 0) {
        setInitialInquiries((previousRows: any) => {
          const currentRows = [...previousRows];
          const updates = _.intersectionBy(locates, previousRows, "inquiry_id");
          const inserts = _.differenceBy(locates, previousRows, "inquiry_id");
          if (_.isArray(inserts) && inserts?.length > 0) {
            const dataRows = inserts?.map((row: any) => {
                return {
                  ...row,
                  requested_time: moment(row.requested_time).format('HH:mm:ss'),
                  response_time: moment(row.response_time).format('HH:mm:ss')
                };
              });
            setInsertInquiryRows(dataRows);
          }

          updates?.forEach((locate: any) => {
            const index = currentRows?.findIndex(
              (loc) => loc?.inquiry_id === locate?.inquiry_id
            );
            if (index >= 0) {
              currentRows[index] = locate;
            }
          });

          return currentRows;
        });

      }
    }
  };

  useEffect(() => {
    if (
      insertInquiryRows &&
      _.isArray(insertInquiryRows) &&
      !_.isEmpty(insertInquiryRows)
    ) {
      setInitialInquiries((previousRows: any) => {
        const currentRows = [...insertInquiryRows, ...previousRows];
        const uniqRows = _.uniqBy(currentRows, "inquiry_id");

        return uniqRows;
      });
    }
  }, [insertInquiryRows]);

  const onFilterChanged = (params: FilterChangedEvent) => {
    const { api, columnApi } = params;
    if (showTotalRow) getName(api, columnApi);
  };

  function onExcelExport() {
    const spreadsheets = [];
    spreadsheets.push(
      gridRef?.current?.api?.getSheetDataForExcel?.({
        sheetName: "inquiry",
      })
    );

    exportMultipleSheetsAsExcel({
      data: spreadsheets,
      fileName: `inquiry.xlsx`,
    });
  }

  const onRefresh = () => {
    setInquiries([]);
    setInitialInquiries([]);
    getInquiries();
    setLastUpdatedDate(moment(new Date()).format("MM/DD/yyyy HH:mm"));
  };

  const onResetFilters = () => {
    setIsResetFilter(!isResetFilter);
  };

  useEffect(() => {
    setStatusFilter({
      isAvailableFilterActive: false,
      isUnAvailableFilterActive: false,
      isTopupFilterActive: false,
      isRejectedFilterActive: false,
      isPendingFilterActive: false,
      isPartialFilterActive: false,
    });
    // onResetFilter?.(isResetFilter);
    // setIsExcludeApproved(false);
    setIsUIFilterActive(false);
    setIsFileFilterActive(false);
    setIsFixFilterActive(false);
  }, [isResetFilter]);

  const onUIFilter = () => {
    setIsUIFilterActive(!isUIFilterActive);
  };

  const onFileFilter = () => {
    setIsFileFilterActive(!isFileFilterActive);
  };

  const onFixFilter = () => {
    setIsFixFilterActive(!isFixFilterActive);
  };

  useEffect(() => {
    let rows = [...initialInquiries];
    setLocateBkpStr(JSON.stringify(rows));
    const statusArray: any[] = [];
    if (statusFilter?.isAvailableFilterActive) {
      statusArray?.push("available");
    }
    if (statusFilter?.isUnAvailableFilterActive) {
      statusArray?.push("unavailable");
    }

    if (statusFilter?.isRejectedFilterActive) {
      statusArray?.push("rejected");
    }
    if (statusFilter?.isPartialFilterActive) {
      statusArray?.push("partial");
    }

    if (rows && _.isArray(rows) && !_.isEmpty(rows)) {
      if (isUIFilterActive && isFileFilterActive && isFixFilterActive) {
        rows = rows?.filter(
          (row: any) =>
            row?.locate_src === "FILE" ||
            row?.locate_src === "UI" ||
            row?.locate_src === "FIX"
        );
      } else if (isUIFilterActive && isFileFilterActive) {
        rows = rows?.filter(
          (row: any) => row?.locate_src === "FILE" || row?.locate_src === "UI"
        );
      } else if (isUIFilterActive && isFixFilterActive) {
        rows = rows?.filter(
          (row: any) => row?.locate_src === "FIX" || row?.locate_src === "UI"
        );
      } else if (isFileFilterActive && isFixFilterActive) {
        rows = rows?.filter(
          (row: any) => row?.locate_src === "FILE" || row?.locate_src === "FIX"
        );
      } else {
        if (isUIFilterActive) {
          rows = rows?.filter((row: any) => row?.locate_src === "UI");
        } else if (isFileFilterActive) {
          rows = rows?.filter((row: any) => row?.locate_src === "FILE");
        } else if (isFixFilterActive) {
          rows = rows?.filter((row: any) => row?.locate_src === "FIX");
        }
      }

      if (statusArray?.length > 0) {
        rows = rows?.filter((row: any) =>
          _.includes(statusArray, row?.status?.toLowerCase())
        );
      }
      if (globalClient && !_.isEmpty(globalClient) && globalClient !== "all") {
        rows = rows?.filter((row: any) => row?.cpty === globalClient);

        if (rows?.length > 0) {
          const currentRowId = rows[0]?.inquiry_id;
          // setCurrentRowId(currentRowId);
        }
      }

      setInquiries([...rows]);
    }
  }, [
    isFileFilterActive,
    isFixFilterActive,
    isUIFilterActive,
    statusFilter,
    initialInquiries,
    globalClient,
  ]);

  const globalSearchRef = useRef<any>(null);
  
  const onFilterTextChange = _.debounce((e: any) => {
    let filterDataLoan: any = gridRef?.current?.api?.setQuickFilter(
      e.target.value
    );
    gridRef?.current?.api?.setQuickFilter(e.target.value);
    gridRef?.current?.api?.applyTransaction({
      update: filterDataLoan,
    });
  }, 800);

  
     useEffect(() => {
      if (newRows && _.isArray(newRows) && newRows?.length > 0) {
          setInitialInquiries((previousRows: any) => {
          return [...newRows, ...previousRows]
        })
      }
    }, [newRows])

  return (
    <div
      className={"" + gridTheme}
      style={{
        height: `97%`,
        width: "100%",
      }}
    >
      
        <>
          <div className="d-flex flex-row justify-content-between">
            <div className="d-flex flex-row justify-content-start col-10">
             {isAdmin && (<>
              <Typography
                style={{
                  height: "2%",
                  paddingLeft: "0.2rem",
                  paddingTop: "0.3rem",
                  paddingBottom: "0.3rem",
                }}
                className="d-flex flex-row justify-content-start"
              >
                Inquiry
              </Typography>
             </>)}
              <div
                className="globalfiltermaindivLocate d-flex flex-row justify-content-start mt-1 ms-1"
                style={{width:'20rem'}}
              >
                <input
                  type="search"
                  placeholder="Global search..."
                  id="filter-text-box-sec"
                  onInput={onFilterTextChange}
                  ref={globalSearchRef}
                  style={{ width: "100%" }}
                />
              </div>
              <div className="d-flex flex-row justify-content-between mb-1 me-4">
                <div
                  className={
                    "d-flex flex-row justify-content-start ms-4 align-baseline align-self-center align-items-center"
                  }
                >
                  <div
                    className="border p-2 d-flex align-items-center justify-content-between position-relative"
                    style={{
                      // width: "160px",
                      height: "37px",
                      borderColor: "#ccc",
                      borderWidth: "1px",
                      borderStyle: "solid",
                      borderRadius: "5px",
                    }}
                  >
                    <div
                      className="position-absolute bg-white"
                      style={{
                        top: "-1px",
                        left: "9px",
                        width: "47px",
                        height: "5px",
                      }}
                    ></div>

                    <label
                      className="position-absolute px-1"
                      style={{
                        top: "-5px",
                        left: "10px",
                        fontSize: "12px",
                        paddingInline: "5px",
                      }}
                    >
                      Source
                    </label>

                    <div className="d-flex gap-3">
                      <div className="form-check d-flex align-items-center">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="ui"
                          onChange={onUIFilter}
                          checked={isUIFilterActive}
                          style={{ fontSize: "12px" }}
                        />
                        <label
                          className="form-check-label ms-1"
                          htmlFor="ui"
                          style={{
                            fontSize: "12px",
                          }}
                        >
                          UI
                        </label>
                      </div>

                      <div className="form-check d-flex align-items-center">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="file"
                          onChange={onFileFilter}
                          checked={isFileFilterActive}
                          style={{ fontSize: "12px" }}
                        />
                        <label
                          className="form-check-label ms-1"
                          htmlFor="file"
                          style={{
                            fontSize: "12px",
                          }}
                        >
                          File
                        </label>
                      </div>

                      <div className="form-check d-flex align-items-center">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="fix"
                          onChange={onFixFilter}
                          checked={isFixFilterActive}
                          style={{ fontSize: "12px" }}
                        />
                        <label
                          className="form-check-label ms-1"
                          htmlFor="fix"
                          style={{
                            fontSize: "12px",
                          }}
                        >
                          Fix
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="d-flex flex-row justify-content-start ms-4 align-baseline align-self-center align-items-center">
                  <div
                    className="border p-2 d-flex align-items-center justify-content-between position-relative"
                    style={{
                      height: "37px",
                      borderColor: "#ccc",
                      borderWidth: "1px",
                      borderStyle: "solid",
                      borderRadius: "5px",
                    }}
                  >
                    <div
                      className="position-absolute bg-white"
                      style={{
                        top: "-1px",
                        left: "9px",
                        width: "45px",
                        height: "5px",
                      }}
                    ></div>

                    <label
                      className="position-absolute px-1"
                      style={{
                        top: "-5px",
                        left: "10px",
                        fontSize: "12px",
                        paddingInline: "5px",
                      }}
                    >
                      Status
                    </label>

                    <div className="d-flex gap-3 flex-row">
                      <div className="form-check d-flex align-items-center">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="new"
                          onChange={() => {
                            setStatusFilter((status: any) => {
                              return {
                                ...status,
                                isAvailableFilterActive:
                                  !status?.isAvailableFilterActive,
                              };
                            });
                          }}
                          checked={statusFilter?.isAvailableFilterActive}
                          style={{ fontSize: "12px" }}
                        />
                        <label
                          className="form-check-label ms-1"
                          htmlFor="new"
                          style={{
                            fontSize: "12px",
                          }}
                        >
                          Available
                        </label>
                      </div>

                      <div className="form-check d-flex align-items-center">
                        <input
                          style={{ fontSize: "12px" }}
                          className="form-check-input"
                          type="checkbox"
                          id="approved"
                          onChange={() => {
                            setStatusFilter((status: any) => {
                              return {
                                ...status,
                                isUnAvailableFilterActive:
                                  !status?.isUnAvailableFilterActive,
                              };
                            });
                          }}
                          checked={statusFilter?.isUnAvailableFilterActive}
                        />
                        <label
                          className="form-check-label ms-1"
                          htmlFor="approved"
                          style={{
                            fontSize: "12px",
                          }}
                        >
                          UnAvailable
                        </label>
                      </div>

                      <div className="form-check d-flex align-items-center">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="rejected"
                          style={{ fontSize: "12px" }}
                          onChange={() => {
                            setStatusFilter((status: any) => {
                              return {
                                ...status,
                                isRejectedFilterActive:
                                  !status?.isRejectedFilterActive,
                              };
                            });
                          }}
                          checked={statusFilter?.isRejectedFilterActive}
                        />
                        <label
                          className="form-check-label ms-1"
                          htmlFor="rejected"
                          style={{
                            fontSize: "12px",
                          }}
                        >
                          Rejected
                        </label>
                      </div>
                      <div className="form-check d-flex align-items-center">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="partial"
                          style={{ fontSize: "12px" }}
                          onChange={() => {
                            setStatusFilter((status: any) => {
                              return {
                                ...status,
                                isPartialFilterActive:
                                  !status?.isPartialFilterActive,
                              };
                            });
                          }}
                          checked={statusFilter?.isPartialFilterActive}
                        />
                        <label
                          className="form-check-label ms-1"
                          htmlFor="partial"
                          style={{
                            fontSize: "12px",
                          }}
                        >
                          Partial
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="d-flex align-items-center">
                  <Button
                    variant="outlined"
                    color="error"
                    size="small"
                    className="ms-4 icon-cursor-pointer"
                    onClick={onResetFilters}
                    sx={{ cursor: "pointer" }}
                  >
                    Reset
                  </Button>
                </div>
              </div>
            </div>

            <div className="d-flex flex-row justify-content-end col-2">
              
              <div className="form-check form-switch d-flex align-self-center align-items-center me-2">
                <input
                  checked={showTotalRow}
                  onChange={() => setShowTotalRow((prev) => !prev)}
                  className="form-check-input me-2"
                  type="checkbox"
                  role="switch"
                  id="gridTotalToggle"
                  title="Turn on/off totals"
                  style={{ fontSize: "medium" }}
                />
                <label
                  className="form-check-label text-nowrap mb-0 align-self-center"
                  style={{ fontSize: "small" }}
                  htmlFor="gridTotalToggle"
                  title="Turn on/off totals"
                >
                  Show Totals
                </label>
              </div>
              <span
                className="borrowExceldnld float-start ms-1"
                onClick={onExcelExport}
                title="Download Excel"
              >
                <img
                  src={excel}
                  alt=""
                  style={{
                    height: "1.8rem",
                    width: "1.8rem",
                    cursor: "pointer",
                  }}
                />
              </span>

              <div
                className="d-flex justify-content-end align-items-center cursor-pointer ms-1 pl-0"
                onClick={onRefresh}
                title="Refresh Data"
              >
                <RefreshIcon
                  style={{
                    cursor: "pointer",
                    marginRight: "0.5rem",
                    color: "#1E355E",
                  }}
                  titleAccess={`Last updated on: ${lastUpdatedDate}`}
                />
              </div>
            </div>
          </div>
        </>
      
      <AgGridReact
        ref={gridRef}
        headerHeight={26}
        defaultColDef={defaultColDef}
        rowHeight={26}
        columnDefs={columnDefs}
        getRowId={getRowId}
        onRowDataUpdated={onGridRowDataChanged}
        rowData={inquiries}
        suppressRowClickSelection={false}
        suppressAggFuncInHeader={true}
        enableRangeSelection={true}
        onGridReady={onGridReady}
        rowClassRules={rowClassRules}
        autoGroupColumnDef={autoGroupColumnDef}
        groupSelectsChildren={true}
        groupSelectsFiltered={true}
        sideBar={sideBar}
        animateRows={false}
        pivotMode={false}
        cacheQuickFilter={true}
        isExternalFilterPresent={isExternalFilterPresent}
        doesExternalFilterPass={onDoesfilter}
        getContextMenuItems={getContextMenuItems}
        quickFilterText={globalSearch}
        getRowStyle={getRowStyle}
        overlayLoadingTemplate={
          '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>'
        }
        rowSelection={"single"}
        onSelectionChanged={onSelectionChanged}
        onFirstDataRendered={onFirstDataRendered}
        onFilterChanged={onFilterChanged}
        suppressAnimationFrame={true}
      ></AgGridReact>
    </div>
  );
};

export default EnquiryGrid;
